import React from 'react';
import NoData from 'components/_common/NoData';
import Loading from 'components/_common/Loading';
import SearchFilter from 'components/_common/SearchFilter';
import PageUtil from 'utils/Page.util';
import { PaginationControl } from 'react-bootstrap-pagination-control';
import { DateType, ReceptionItemKind, getReceptionStatus, getReceptionType, getInboundMethod, getFlowType, ReceptionType } from 'enums/reception.enum';

const InboundV = ({
    params,
    setParams,
    handleChange,
    onSearch,
    setSearch,
    onClearFilter,
    onToggleDatePickerMode,
    onHandleSearchDate,
    onOpenCreate,
    onOpenEdit,
    onChangeStatus,
    onTodaySearch,
    onSaveInboundDate,
    handleExportExcel,
}) => {
    const { list, isLoaded, error, search, kpiData, kpiLoaded } = params;

    const dateTypeOptions = [
        { value: DateType.RECEIVED, label: '접수일자' },
        { value: DateType.INBOUND, label: '택배입고일' }
    ];

    // 검색 매개변수 변경 핸들러
    const handleSearchChange = (field, value) => {
        const cur = PageUtil.deepCopy(params);
        cur.search[field] = value;
        setParams(cur);
    };



    // KPI 스켈레톤 로딩 컴포넌트
    const KPISkeleton = () => (
        <div className="mb-4">
            <div className="row g-3 mb-4">
                <div className="col-md-12">
                    <div className="card">
                        <div className="card-body">
                            <div className="d-flex justify-content-between align-items-center">
                                <div style={{ width: '60%' }}>
                                    <div className="placeholder-glow">
                                        <span className="placeholder col-8"></span>
                                    </div>
                                    <div className="placeholder-glow mt-2">
                                        <span className="placeholder col-6"></span>
                                    </div>
                                </div>
                                <div>
                                    <div className="placeholder-glow">
                                        <span className="placeholder col-12" style={{ width: '40px', height: '40px' }}></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

    return (
        <>
            {isLoaded && error == null ? (
                <>
                    <div className="content-header">
                        <h1>
                            <span>입고관리</span>
                        </h1>
                    </div>

                    {/* ===== KPI 섹션 시작 ===== */}
                    {!kpiLoaded ? (
                        <KPISkeleton />
                    ) : (
                        <div className="row mb-3">
                            <div className="col-12">
                                <div className="card card-outline card-warning">
                                    <div className="card-header">
                                        <h3 className="card-title">
                                            <i className="fas fa-exclamation-triangle mr-2"></i>
                                            입고관리 현황
                                        </h3>
                                    </div>
                                    <div className="card-body">
                                        <div className="row">
                                            {/* 미입고(맞교환) 건수 */}
                                            <div className="col-md-4 col-sm-6">
                                                <div className="info-box bg-warning">
                                                    <span className="info-box-icon">
                                                        <i className="fas fa-box-open"></i>
                                                    </span>
                                                    <div className="info-box-content">
                                                        <span className="info-box-text text-white">미입고(맞교환)</span>
                                                        <span className="info-box-number text-white">
                                                            {kpiData.pendingExchangeCount.toLocaleString()}건
                                                        </span>
                                                        <div className="progress" style={{ backgroundColor: 'rgba(255,255,255,0.2)' }}>
                                                            <div className="progress-bar" style={{ width: '100%', backgroundColor: 'rgba(255,255,255,0.4)' }}></div>
                                                        </div>
                                                        <span className="progress-description text-white">
                                                            입고예정 상태의 맞교환 건수
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-md-4 col-sm-6">
                                                <div className="info-box bg-success">
                                                    <span className="info-box-icon">
                                                        <i className="fas fa-box-open"></i>
                                                    </span>
                                                    <div className="info-box-content">
                                                        <span className="info-box-text text-white">미입고(신상맞교환)</span>
                                                        <span className="info-box-number text-white">
                                                            {kpiData.pendingNewExchangeCount.toLocaleString()}건
                                                        </span>
                                                        <div className="progress" style={{ backgroundColor: 'rgba(255,255,255,0.2)' }}>
                                                            <div className="progress-bar" style={{ width: '100%', backgroundColor: 'rgba(255,255,255,0.4)' }}></div>
                                                        </div>
                                                        <span className="progress-description text-white">
                                                            입고예정 상태의 신상맞교환 건수
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-md-4 col-sm-6">
                                                <div className="info-box bg-info">
                                                    <span className="info-box-icon">
                                                        <i className="fas fa-box-open"></i>
                                                    </span>
                                                    <div className="info-box-content">
                                                        <span className="info-box-text text-white">미입고(출장)</span>
                                                        <span className="info-box-number text-white">
                                                            {kpiData.pendingTripCount.toLocaleString()}건
                                                        </span>
                                                        <div className="progress" style={{ backgroundColor: 'rgba(255,255,255,0.2)' }}>
                                                            <div className="progress-bar" style={{ width: '100%', backgroundColor: 'rgba(255,255,255,0.4)' }}></div>
                                                        </div>
                                                        <span className="progress-description text-white">
                                                            입고예정 상태의 출장 건수
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                    {/* ===== KPI 섹션 끝 ===== */}

                    <div className="container-fluid">
                        {/* 고급 검색 필터 */}
                        <SearchFilter
                            searchParams={search}
                            onSearchChange={handleSearchChange}
                            onSearch={onSearch}
                            onClearFilter={onClearFilter}
                            todayButtonName={"입고 Today"}
                            onTodaySearch={onTodaySearch}
                            showStatusFilter={false}
                            showTypeFilter={false}
                            showDateRange={true}
                            showDateType={true}
                            dateTypeOptions={dateTypeOptions}
                            placeholder="고객명, 연락처, 보일러명 등 검색"
                            onExcelDownload={handleExportExcel}
                            onOpenCreate={onOpenCreate}
                            additionalFilters={

                                <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                    <label style={{
                                        fontSize: '14px',
                                        fontWeight: '600',
                                        color: '#6b7280',
                                        marginBottom: 0,
                                        whiteSpace: 'nowrap'
                                    }}>
                                        입고/택발
                                    </label>
                                    <div style={{ display: 'flex', alignItems: 'center', position: 'relative' }}>
                                        {/* <input
                                            type="search"
                                            className="form-control form-control-sm"
                                            style={{ width: '280px', paddingRight: '32px' }}
                                            placeholder={placeholder}
                                            value={searchParams.keyword || ''}
                                            onChange={(e) => handleInputChange('keyword', e.target.value)}
                                            onKeyPress={handleKeyPress}
                                        /> */}
                                        <div className='form-control form-control-sm'>
                                            <select
                                                className="form-select form-select-sm"
                                                value={search.flowType || ''}
                                                onChange={(e) => handleSearchChange('flowType', e.target.value)}
                                                style={{ width: '100%' }}
                                            >
                                                <option value="">전체</option>
                                                {getFlowType().map(flow => (
                                                    <option key={flow.value} value={flow.value}>
                                                        {flow.label}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                </div>

                                // <div className="row g-12">
                                //     <div className="col-12">
                                //         <label className="form-label text-muted small">입고상태</label>
                                //         <div className='form-control form-control-sm'>
                                //             <select
                                //                 className="form-select form-select-sm"
                                //                 value={search.flowType || 'all'}
                                //                 onChange={(e) => handleSearchChange('flowType', e.target.value)}
                                //                 style={{ width: '100%' }}
                                //             >
                                //                 <option value="all">전체</option>
                                //                 {getFlowType().map(flow => (
                                //                     <option key={flow.value} value={flow.value}>
                                //                         {flow.label}
                                //                     </option>
                                //                 ))}
                                //             </select>
                                //         </div>
                                //     </div>
                                // </div>
                            }
                        />

                        {/* 목록 */}
                        <div className="card card-outline card-dark">
                            <div className="card-header">
                                <div className="card-title">입고 목록</div>
                                <div className="card-tools">
                                    <span className="badge bg-secondary">
                                        {PageUtil.formatToKRW(params.total)} 건
                                    </span>
                                </div>
                            </div>
                            <div className="card-body table-responsive p-0">
                                {list.length === 0 ? (
                                    <NoData />
                                ) : (
                                    <table className="table text-nowrap">
                                        <thead>
                                            <tr>
                                                <th>택배입고일</th>
                                                <th>연락처</th>
                                                <th>고객명</th>
                                                <th>주소</th>
                                                <th>출장자</th>
                                                <th>접수내용</th>
                                                <th>택배입고물품</th>
                                                <th>입고/택발</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {list.map((row) => (
                                                <tr key={row.id} style={row.blacklist ? { backgroundColor: '#ffe6e6' } : {}}>
                                                    <td style={{ fontSize: '15px', fontWeight: 'bold' }}>
                                                        {(row.items?.find(p => p.courierInboundDate)?.courierInboundDate || '') + (row.items?.filter(p => p.courierInboundDate)?.length > 1 ? ' 外' : '')}
                                                    </td>
                                                    <td>
                                                        <a onClick={() => onOpenEdit(row)} style={{ cursor: 'pointer' }}>
                                                            {row.phone1 || ''}
                                                        </a>
                                                    </td>
                                                    <td>
                                                        <strong>{row.customerName || ''}</strong>
                                                    </td>
                                                    <td>{(row.address || '')}</td>
                                                    <td>
                                                        <strong>{row.tripCard?.agent || ''}</strong>
                                                    </td>
                                                    <td>
                                                        {row.requestNote || ''}
                                                    </td>
                                                    <td>
                                                        {row.inboundNote || ''}
                                                    </td>
                                                    <td>
                                                        {getFlowType().find((f) => f.value === row.items?.find(p => p.kind === ReceptionItemKind.BOILER)?.flow)?.label || row.items?.find(p => p.kind === ReceptionItemKind.BOILER)?.flow || ''}
                                                    </td>

                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                )}
                            </div>

                            {/* 페이징 */}
                            {list.length > 0 && (
                                <PaginationControl
                                    page={params.search.page}
                                    total={params.total}
                                    limit={params.search.rows}
                                    changePage={(page) => {
                                        const cur = PageUtil.deepCopy(params);
                                        cur.search.page = page;
                                        setParams(cur);
                                        setSearch(true);
                                    }}
                                    ellipsis={1}
                                />
                            )}
                        </div>
                    </div>
                </>
            ) : (
                <Loading />
            )}
        </>
    );
};

export default InboundV;